import React, { useState } from 'react';

function ShelyUrls({ sheliId, compact = false, hint = true }) {
  if (!sheliId) return null;

  const base = window.location.origin;
  const urlOpen = `${base}/api/sheli/pulse?sheli_id=${encodeURIComponent(sheliId)}&status=1`;
  const urlClose = `${base}/api/sheli/pulse?sheli_id=${encodeURIComponent(sheliId)}&status=0`;

  return (
    <div className={`sheli-urls ${compact ? 'compact' : ''}`}>
      {!compact && (
        <div className="sheli-urls-header">
          <h4>קישורים להגדרת הרכיב</h4>
          {hint && (
            <p className="sheli-urls-hint">
              העתק כל קישור אל URL Action מתאים בממשק הרכיב (כניסה מופעלת / כניסה כבויה).
            </p>
          )}
        </div>
      )}
      <UrlRow label="כשהשער נפתח (כניסה מופעלת)" url={urlOpen} />
      <UrlRow label="כשהשער נסגר (כניסה כבויה)" url={urlClose} />
    </div>
  );
}

function UrlRow({ label, url }) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(url);
      } else {
        const ta = document.createElement('textarea');
        ta.value = url;
        ta.style.position = 'fixed';
        ta.style.opacity = '0';
        document.body.appendChild(ta);
        ta.focus();
        ta.select();
        document.execCommand('copy');
        document.body.removeChild(ta);
      }
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch (err) {
      alert('העתקה אוטומטית נכשלה - סמן ידנית ולחץ Ctrl+C');
    }
  };

  return (
    <div className="sheli-url-row">
      <div className="sheli-url-label">{label}</div>
      <div className="sheli-url-box">
        <input
          readOnly
          value={url}
          dir="ltr"
          onFocus={e => e.target.select()}
          onClick={e => e.target.select()}
        />
        <button
          type="button"
          onClick={handleCopy}
          className={`btn btn-sm ${copied ? 'btn-copied' : 'btn-primary'}`}
        >
          {copied ? '✓ הועתק' : 'העתק'}
        </button>
      </div>
    </div>
  );
}

export default ShelyUrls;
